// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"535":"login","826":"class.index"}[chunkId] + "." + {"535":"9a249729","826":"cc7e7b2a"}[chunkId] + ".css";
};